<div [@routerTransition]>

  <div class="row">

    <div class="col-md-3 columnfeatures1">

      <div class="card paddin-left-5px" *ngIf="ShowList">
        <div class="card-header wh-header header3 padding-right-32px padding-bottom-0px padding-left-10px">

          <div class="row margin-top10px nav-link-hand">

            <label class="wh-header font-weight-normal padding-left-5px card-title-schedule-bl border-radius-4px padding-top-10px padding-bottom-4px margin-bottom-0px">
              Access Rights
            </label>

          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">

          <div>
            <div class="chatsd product-chart-wrapper product-chat-height-650 agreement-chart-wrapper scroll padding-lrt ">
              <div class="row border-bottom rowfor2 margin-left-5px margin-right-0px nav-link-hand padding-bottom-0px padding-top-0px" *ngFor="let l of modules" (click)="SelectedModule(l)">
                <div class="col-md-12 margin-top-5px margin-bottom-5px">

                  <div class="row">
                    <div class="col-md-12 padding-left-10px">
                      <div class="row margin-left-0px">
                        <label class="margin-bottom-0px f2 font-weight-bold" style="color: #212529 !important; font-size: 14px !important;">{{l.ModuleName || l.modulename || l.moduleName}}</label>
                      </div>

                      <div class="row margin-left-0px">
                        <label class="margin-bottom-0px font-size-14 font-weight-normal" style="color: #6c757d !important; font-size: 12px !important;">{{l.Description || l.description}}</label>
                      </div>

                    </div>

                  </div>

                </div>
              </div>


            </div>
          </div>

        </div>

      </div>
    </div>



    <div class="col-md-9 columnfeatures2">
      <div class="padding-right-0px background-white">
        <div class="">

          <div class="card top-link" *ngIf="ShowList2">
            <div class="card-header wh-header padding-bottom-6px">
              <div class="row">
                <div class="col-md-4 padding-left-10px font-weight-bold" style="color: #212529 !important; font-size: 15px !important;" *ngIf="SelectedModuleDetails">
                  {{SelectedModuleDetails.ModuleName}}
                </div>

                <div class="col-md-8 ">
                  <div class="row my-profile-form">
                    <div class="offset-md-3 col-md-2 padding-right-0px text-align-right">
                      <label class="margin-bottom-0px margin-top-10 font-size-14 font-weight-normal" style="color: #212529 !important;">Select Role</label>
                    </div>
                    <div class="col-md-3">
                      <select class="form-control" [ngModel]="SelectedRoleName" (change)="onChange($event.target.value)" style="color: #212529 !important; background-color: #ffffff !important;">
                        <option value="" style="color: #6c757d !important;">Select Role</option>
                        <option *ngFor="let l of Roles" [value]="l.RoleName" style="color: #212529 !important; background-color: #ffffff !important;">
                          {{l.RoleName}}
                        </option>
                      </select>
                    </div>
                    <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
                      <!--<form novalidate="" #f="ngForm" class="display-inherit" >
                        <div class="clear-form">
                          <input type="text" class="form-control" placeholder="Search" name="searchBar" maxlength="15">
                        </div>
                        <button class="btn font-size-13px actions-btn-prime margin-right-auto margin-left-5px height-33px">Go</button>
                      </form>-->
                      <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)" class="SearchAccess"></search-list>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div class="card-body padding-top-0px padding-left-0px">
              <!--<div *ngIf="ApiResData">
                {{ApiResData.Result}}
              </div>-->
              <div class="chatsd product-chart-wrapper agreement-chart-wrapper ps2 padding-lrt height-Scroll-638px">
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-component">
                      <div class="table-responsive overflow-x">


                        <table class="table table-striped margin-left-zero"
                               cols="auto,2*,*,*,*,*,*,*">

                          <thead class="">
                            <tr>
                              <th class="">
                                Feature ID
                              </th>

                              <th class="">
                                Features
                              </th>

                              <th class="padding-left-0px">
                                Allow
                              </th>




                            </tr>
                          </thead>

                          <tbody class="table-body">
                            <tr *ngFor="let l of pdata">
                              <td>
                                <label class="margin-bottom-0px font-weight-bold" style="color: #212529 !important;">{{l.FeatureName}}</label>
                              </td>
                              <td class=" td-padding-tb">
                                <label class="margin-bottom-0px" style="color: #333333 !important;">{{l.FeatureDescription}}</label>
                              </td>
                              <td class=" td-padding-tb">
                                <input type="checkbox" [(ngModel)]="l.HasAccess" (change)="onSubmit(l, $event)" class="width-15px">
                              </td>

                            </tr>

                          </tbody>

                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>


  </div>


</div>



